import { parsePhoneNumberFromString } from 'libphonenumber-js';

export class PhoneNumber {
    countryCode: number;
    nationalNumber: string;

    constructor(value: PhoneNumber) {
        if (value) {
            this.countryCode = value.countryCode;
            this.nationalNumber = value.nationalNumber;
        }
    }

    static fromData(value: string) {
        if (value) {
            const phone: any = parsePhoneNumberFromString(value);
            if (phone) {
                return new PhoneNumber({
                    countryCode: +phone.countryCallingCode,
                    nationalNumber: phone.nationalNumber
                } as PhoneNumber);
            } else {
                return new PhoneNumber({
                    countryCode: null,
                    nationalNumber: value
                });
            }
        }

        return {
            countryCode: null,
            nationalNumber: null
        };
    }

    toString() {
        return this && this.nationalNumber ? (this.countryCode ? '+' + this.countryCode : '') + this.nationalNumber : null;
    }
}
